// extracted by mini-css-extract-plugin
export default {"rightPanelContent":"rightPanel_rightPanelContent__PEHOy","first":"rightPanel_first__c1Ls8","second":"rightPanel_second__l4VgM"};